var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('expense-toolbar',{attrs:{"heading":"Expenses"}}),_c('expense-table',{attrs:{"show-user":true,"show-job":true,"editable":true,"filtering-tools":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }